module.exports = __webpack_public_path__ + "static/media/texpert-img1.c38dd805.jpg";